import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'react';
import Log from '../../../Kodansha/Services/Logger';
export function GTagManagerTriggerLoad() {
    if (navigator.userAgent === 'RenderBot') {
        return;
    }
    if (!window['dataLayer']) {
        var gtmScriptNode = document.getElementById('gtm-script-container');
        eval(gtmScriptNode === null || gtmScriptNode === void 0 ? void 0 : gtmScriptNode.textContent);
    }
}
export function GTagManager(props) {
    if (navigator.userAgent === 'RenderBot') {
        return (_jsx(_Fragment, {}));
    }
    Log.info("Loading GTM");
    var noscript = "\n                            <iframe \n                                role=\"presentation\"\n                                src=\"https://www.googletagmanager.com/ns.html?id=".concat(props.Id, "\"\n                                height=\"0\"\n                                width=\"0\"\n                                style=\"display:none;visibility:hidden\">\n                            </iframe>");
    var script = "\n                    (function(w,d,s,l,i){w[l]=w[l]||[];\n                        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});\n                        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n                        j.async=true;\n                        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                    })(window,document,'script','dataLayer','".concat(props.Id, "');");
    return (_jsxs(_Fragment, { children: [_jsx("script", { id: props.scriptId, defer: true, dangerouslySetInnerHTML: { __html: script } }), _jsx("noscript", { dangerouslySetInnerHTML: { __html: noscript } })] }));
}
